export const couponInitialValues = {
    first_name: '',
    last_name: '',
    email: '',
    phone: '',
    location: '',
};
